import {
  Cluster,
  DefaultRenderer,
  Marker,
  MarkerClusterer,
} from "@googlemaps/markerclusterer";
import { useEffect, useState } from "react";

import { AdvancedMarker, Map, useMap } from "@vis.gl/react-google-maps";
import { TicketStatus } from "../../../../utils/constants";
import { CustomTooltip } from "../../../../styles/TooltipStyles";
import { TOOLTIP_COLORS } from "../../../../styles/Variables";
import { GetVmsBoardDetailsResult } from "./queries/types";
import VmsImage from "../../../../images/ItemIcons/Signal Status.svg";
import CheckConnectivity from "./CheckConnectivity";
import { MapAutocomplete } from "../maps/MapAutocomplete";
import CoordinatesSearch from "../DashBoardMapsView/CoordinatesSearch";
import MapHandler from "../DashBoardMapsView/MapHandler";

export interface longLatPos {
  lat: number;
  lng: number;
}

type PointsProp = {
  points: GetVmsBoardDetailsResult[];
};
type Tree = {
  key: string;
  name: string;
  lat: number;
  lng: number;
  lastConnected: string;
  isDeviceOn: boolean;
};
interface idStatus {
  id: number;
  ticketStatus: TicketStatus;
}

export interface MapProps {
  items: GetVmsBoardDetailsResult[];
  clusterer: React.MutableRefObject<MarkerClusterer | null>;
  selectedPlace: google.maps.places.PlaceResult | null;
  searchCoordinates: string;
}

const MapsView = ({
  items,
  clusterer,
  selectedPlace,
  searchCoordinates,
}: MapProps) => {
  const defaultCenter = {
    lat: 12.981010391578677,
    lng: 77.60151962452281,
  };

  const Markers = ({ points }: PointsProp) => {
    const map = useMap();
    const [markers, setMarkers] = useState<{
      [key: string]: { marker: Marker; idStatus: idStatus };
    }>({});

    useEffect(() => {
      clusterer.current = null;
    }, []);
    useEffect(() => {
      if (!map) return;
      if (!clusterer.current)
        clusterer.current = new MarkerClusterer({
          map,
          // renderer: new CustomRenderer(),
        });
    }, [map, points]);

    useEffect(() => {
      clusterer.current?.clearMarkers();

      Object.values(markers).forEach((mark) => {
        clusterer.current?.addMarkers(Object.values(mark.marker));
      });
    }, [markers, points]);

    return (
      <>
        {points.map(
          (
            {
              prodLatitude,
              prodLongitude,
              id,
              ticketStatus,
              lastConnected,
              address,
              isDeviceOn,
            },
            key
          ) => {
            const itemPoint: Tree = {
              key: JSON.stringify({
                id,
                prodLatitude,
                prodLongitude,
              }),
              lat: Number(prodLatitude),
              lng: Number(prodLongitude),
              name: id.toString(),
              lastConnected: lastConnected,
              isDeviceOn: isDeviceOn,
            };

            return (
              <AdvancedMarker
                key={key}
                position={itemPoint}
                zIndex={ticketStatus === TicketStatus.OPEN ? 4 : 1}
                className={`vms-marker${
                  isDeviceOn ? "-on" : "-off"
                } feature vms-boards--turned${isDeviceOn ? "-on" : "-off"}`}
              >
                <CustomTooltip
                  title={
                    <>
                      {address}
                      {lastConnected}
                    </>
                  }
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: TOOLTIP_COLORS.VARIABLE,
                        "& .MuiTooltip-arrow": {
                          color: TOOLTIP_COLORS.VARIABLE,
                        },
                      },
                    },
                  }}
                >
                  <img
                    src={VmsImage}
                    className={`vms-boards--turned${
                      isDeviceOn ? "-on" : "-off"
                    }`}
                    alt="Image not found"
                  />
                </CustomTooltip>

                <div
                  className={`tip vms-boards--turned${
                    isDeviceOn ? "-on" : "-off"
                  }`}
                ></div>
              </AdvancedMarker>
            );
          }
        )}
      </>
    );
  };

  return (
    <>
      <div className="vms-boards__maps-view">
        <Map
          defaultZoom={13}
          defaultCenter={defaultCenter}
          mapId={process.env.React_App_Map_ID}
          disableDefaultUI={true}
          gestureHandling={"greedy"}
        >
          <Markers points={items} />
          <MapHandler
            place={selectedPlace}
            searchCoordinates={searchCoordinates}
          />
          <CoordinatesSearch searchCoordinates={searchCoordinates} />
        </Map>
      </div>
    </>
  );
};

export default MapsView;
